<rma-location-profile-page #profilePage>
  @if (profilePage.profiles$ | async; as profiles) {
    @if (profiles.total) {
      <div class="flex flex-col gap-4">
        @for (profile of profiles.results; track profile.profileCode; let index = $index; let isFirst = $first) {
          @if (index <= 3) {
            <rma-group-profile-card [profile]="profile" [isFirst]="isFirst" />
          } @else {
            @if (profilePage.isServer) {
              <rma-group-profile-card [profile]="profile" />
            } @else {
              @defer (on viewport) {
                <rma-group-profile-card [profile]="profile" />
              } @placeholder {
                <rma-skeleton-block class="min-h-96 w-full" />
              } @error {}
            }
          }
        }
      </div>
      <rma-pagination class="mt-6 block" [pagedList]="profiles" />
    } @else {
      <rma-location-empty [type]="profilePage.tabType()" [location]="profilePage.location().name" />
    }
  }
</rma-location-profile-page>
